// Cost category data model
//
// Each category object: { id, name, isActive, order }
//
// Stored in companies/{id}/meta/extras.costCategories, mirroring the
// data-as-config pattern used for jobTypes / customFields / pricingPresets.
//
// Categories are SOFT-hidden (isActive:false), never hard-deleted, so a cost
// entry that references a category id can always resolve to a display name even
// after the category is retired. Every industry's shipped defaults use STABLE
// string ids so that read-time seeding (which can run on any client, including
// non-owners that can't persist) produces identical ids everywhere — a cost
// entry created against 'labor' resolves the same regardless of who seeded.
// The defaults themselves are each industry's own — its pack in
// utils/industryPacks/, read through buildDefaultCostCategoriesForIndustry()
// in utils/industryRegistry.js.

// True when a company has no cost categories yet (needs seeding/backfill).
export function costCategoriesNeedSeed(arr) {
  return !Array.isArray(arr) || arr.length === 0;
}

// Id generator for owner-added custom categories.
export function newCostCategoryId() {
  return `cat_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
}

// Resolve a category id to its current display name. Returns '' when the id is
// empty or unresolvable (caller decides how to render "Uncategorized").
export function categoryNameById(categories, id) {
  if (!id) return '';
  const found = (categories || []).find(c => c && c.id === id);
  return found ? found.name : '';
}
